import React from 'react';
import { InputAdornment, TextField, Typography } from '@mui/material';
import { Search } from '@mui/icons-material';
import { useTranslation } from 'react-i18next';
import { StyledProjectListHeader } from './index.style';

const Header = ({ search, onSearch }) => {
  const { t } = useTranslation();

  return (
    <StyledProjectListHeader>
      <Typography className="title">{t('projectList')}</Typography>

      <TextField
        size="small"
        className="text-field-project"
        variant="outlined"
        hiddenLabel={false}
        value={search}
        placeholder={t('searchProject')}
        onChange={onSearch}
        data-id="search-project"
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              <Search />
            </InputAdornment>
          ),
        }}
      />
    </StyledProjectListHeader>
  );
};

export default Header;
